<template>
  <VanPopup
    v-model:show="store.showJumpSettingModal"
    class="max-h-[90%] min-h-[60%]"
    closeable
    position="bottom"
    round
  >
    <div class="pt-4">
      <h2 class="text-base font-bold text-center">
        {{ $t("game.jumpToSettings") }}
      </h2>

      <div class="flex gap-2.5 px-3 mt-6">
        <div class="flex flex-col items-center">
          <UserAvatar
            :avatar-url="store.characterIdMap[store.activeDialog.character.id!].avatarMedia?.url"
            class="w-[50px] aspect-[3/4] rounded-sm"
          />
          <p class="my-0.5">{{ store.filterOptionText(store.activeDialog) }}</p>
        </div>

        <div class="flex-1 bg-my-dark rounded-md p-2.5 flex items-center">
          <p>
            {{ store.activeDialog.text }}
          </p>
        </div>
      </div>

      <ul>
        <li
          v-for="(option, i) in store.activeDialog.optionzz"
          :key="i"
          class="bg-my-dark p-2.5 my-2.5 flex items-center gap-6"
        >
          <div class="flex-1">
            <p>
              {{ option.text }}
            </p>
            <p
              v-if="option.nextDialog"
              class="bg-primary rounded ml-[68px] px-2.5 py-1 mt-2.5"
            >
              {{ store.filterOptionText(option.nextDialog) }}
              {{ store.filterNextDialogText(option.nextDialog) }}
            </p>
          </div>
          <div @click="clickSetting(option)">
            <span v-if="!option.nextDialog">{{ $t("game.notSet") }} ></span>
            <span v-else>{{ $t("game.modify") }} ></span>
          </div>
        </li>
      </ul>
    </div>
  </VanPopup>
</template>

<script lang="ts" setup>
import { useGalGameEditor } from "@/stores/galGameEditor";

const store = useGalGameEditor();

const clickSetting = (option: GalGameDialogOption) => {
  store.activeDialogOption = option;
  store.showJumpListModal = true;
};
</script>
